import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
import { isVariant } from '@/types';
import * as utils from '@/utils';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
const examBadge = (h, assignment, variant) => utils.ifOrEmpty(assignment.isExam, () => (<b-badge variant={variant} class="mr-2 font-medium uppercase align-self-center">
            exam
        </b-badge>));
const AssignmentName = tsx.component({
    functional: true,
    props: {
        assignment: p.ofType().required,
        badgeVariant: p.ofType().validator(isVariant).default('primary'),
    },
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    render(h, { data, props }) {
        const { assignment, badgeVariant } = props;
        const maybeExamBadge = assignment.isExam ? ' [exam]' : '';
        return (<span class={['assignment-name', 'text-nowrap', data.class, data.staticClass]} style={[data.style, data.staticStyle]} title={`${assignment.name}${maybeExamBadge}`}>
                <span class="mr-2 text-truncate">{assignment.name}</span>
                {examBadge(h, assignment, badgeVariant)}
            </span>);
    },
});
export default AssignmentName;
